module.exports = require("core-js/modules/es6.object.assign");